import { DeleteDialogModal } from "components/elements/DeleteDialogModal";
import { cn } from "lib/cn";
import { trpc } from "lib/trpc";
import { useCallback, useState } from "react";
import { ClientDocumentListEntry } from "@compass/shared/types";

type DeleteDocumentProps = {
    document: ClientDocumentListEntry;
};

export const DeleteDocument = ({ document }: DeleteDocumentProps) => {
    const [deleteId, setDeleteId] = useState<string | null>(null);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

    const utils = trpc.useContext();
    const canDelete = useCallback((document: ClientDocumentListEntry) => document.userCanEdit, []);
    const deleteDocument = trpc.userContent.delete.useMutation({
        onSuccess: () => {
            utils.userContent.list.invalidate();
            setIsDeleteModalOpen(false);
            setDeleteId(null);
        },
    });

    const handleDeleteDocument = () => {
        if (deleteId) {
            deleteDocument.mutate({ fileId: deleteId });
        }
    };

    if (!canDelete(document)) {
        return null;
    }

    return (
        <>
            <button
                className={cn(
                    "cursor-pointer px-4 py-1 text-sm text-red-400 hover:bg-gray-100 hover:text-red-500",
                    deleteDocument.isPending && "cursor-not-allowed text-gray-300",
                )}
                onClick={() => {
                    if (deleteDocument.isPending) return;
                    setDeleteId(document.id);
                    setIsDeleteModalOpen(true);
                }}
            >
                Delete
            </button>
            <DeleteDialogModal
                open={isDeleteModalOpen}
                setOpen={(isOpen) => {
                    setIsDeleteModalOpen(isOpen);
                    if (!isOpen) setDeleteId(null);
                }}
                handleDelete={handleDeleteDocument}
                disabled={deleteDocument.isPending}
                message="This action cannot be undone. This will permanently delete your document."
            />
        </>
    );
};
